package one.healthium.carnivore.presentation.navigation.home.compose

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.unit.dp
import com.arkivanov.decompose.extensions.compose.subscribeAsState
import ifaandroid.apps.carnivore.composeapp.generated.resources.Res
import ifaandroid.apps.carnivore.composeapp.generated.resources.ic_chat_default
import ifaandroid.apps.carnivore.composeapp.generated.resources.ic_home_default
import ifaandroid.apps.carnivore.composeapp.generated.resources.ic_home_selected
import ifaandroid.apps.carnivore.composeapp.generated.resources.ic_insights_default
import ifaandroid.apps.carnivore.composeapp.generated.resources.ic_insights_selected
import ifaandroid.apps.carnivore.composeapp.generated.resources.ic_motivational_phrase_default
import ifaandroid.apps.carnivore.composeapp.generated.resources.ic_motivational_phrase_selected
import ifaandroid.apps.carnivore.composeapp.generated.resources.ic_profile_default
import ifaandroid.apps.carnivore.composeapp.generated.resources.ic_profile_selected
import kotlinx.coroutines.launch
import one.healthium.carnivore.presentation.navigation.home.HomeComponent
import one.healthium.tasks.ui.DailyTasksBadge
import one.healthium.ui.compose.components.AppNavigationBar
import one.healthium.ui.compose.components.AppNavigationBarItem
import one.healthium.ui.compose.components.AppNavigationBarMinHeight
import one.healthium.ui.compose.components.LocalGlobalProgressIndicator
import org.jetbrains.compose.resources.painterResource

@Composable
internal fun BottomNavigation(
    component: HomeComponent,
) {
    val stack by component.stack.subscribeAsState()
    val activeComponent = stack.active.instance
    val scope = rememberCoroutineScope()
    val globalProgressIndicator = LocalGlobalProgressIndicator.current

    AppNavigationBar {
        // Today
        AppNavigationBarItem(
            modifier = Modifier.width(AppNavigationBarMinHeight).testTag("nav_today"),
            icon = {
                val resource = if (activeComponent is HomeComponent.Child.TodayChild) {
                    Res.drawable.ic_home_selected
                } else {
                    Res.drawable.ic_home_default
                }
                Image(
                    painter = painterResource(resource),
                    contentDescription = null,
                )
            },
            selected = activeComponent is HomeComponent.Child.TodayChild,
            onClick = component::onTodayTabClicked,
        )

        // DailyTasks
        AppNavigationBarItem(
            modifier = Modifier.width(AppNavigationBarMinHeight).testTag("nav_tasks"),
            icon = {
                val resource = if (activeComponent is HomeComponent.Child.DailyTasksChild) {
                    Res.drawable.ic_motivational_phrase_selected
                } else {
                    Res.drawable.ic_motivational_phrase_default
                }
                Box {
                    Image(
                        painter = painterResource(resource),
                        contentDescription = null,
                    )
                    DailyTasksBadge(
                        modifier = Modifier
                            .align(Alignment.TopEnd)
                            .offset(x = 8.dp, y = (-8).dp)
                    )
                }
            },
            selected = activeComponent is HomeComponent.Child.DailyTasksChild,
            onClick = component::onDailyTasksTabClicked,
        )

        // Insights
        AppNavigationBarItem(
            modifier = Modifier.width(AppNavigationBarMinHeight).testTag("nav_insights"),
            icon = {
                val resource = if (activeComponent is HomeComponent.Child.InsightsChild) {
                    Res.drawable.ic_insights_selected
                } else {
                    Res.drawable.ic_insights_default
                }
                Image(
                    painter = painterResource(resource),
                    contentDescription = null,
                )
            },
            selected = activeComponent is HomeComponent.Child.InsightsChild,
            onClick = component::onInsightsTabClicked,
        )

        // Chat
        AppNavigationBarItem(
            modifier = Modifier.width(AppNavigationBarMinHeight).testTag("nav_chat"),
            icon = {
                val resource = if (activeComponent is HomeComponent.Child.ChatChild) {
                    Res.drawable.ic_chat_default
                } else {
                    Res.drawable.ic_chat_default
                }
                Image(
                    painter = painterResource(resource),
                    contentDescription = null,
                )
            },
            selected = activeComponent is HomeComponent.Child.ChatChild,
            onClick = {
                scope.launch {
                    globalProgressIndicator.value = true
                    component.onChatTabClicked()
                    globalProgressIndicator.value = false
                }
            },
        )

        // Profile
        AppNavigationBarItem(
            modifier = Modifier.width(AppNavigationBarMinHeight).testTag("nav_profile"),
            icon = {
                val resource = if (activeComponent is HomeComponent.Child.ProfileChild) {
                    Res.drawable.ic_profile_selected
                } else {
                    Res.drawable.ic_profile_default
                }
                Image(
                    painter = painterResource(resource),
                    contentDescription = null,
                )
            },
            selected = activeComponent is HomeComponent.Child.ProfileChild,
            onClick = component::onProfileTabClicked,
        )
    }
}
